var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { WorkspaceGroupsKeyFactory } from '../../query-key-factories';
import { canFetchWorkspaceData } from '../../services';
import { useCurrentMemberByWorkspaceId } from './useCurrentMemberByWorkspaceId';
import { useGetWorkspaceLoginStatus } from './useGetWorkspaceLoginStatus';
export const useGroupsByWorkspaceId = ({ workspaceId, }, { enabled = true } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { query: { data }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const isQueryEnabled = Boolean(data?.privileges?.groupsRead) &&
        canFetchWorkspaceData(workspaceLoginStatus) &&
        enabled;
    const query = useQuery({
        queryKey: WorkspaceGroupsKeyFactory.byWorkspace(workspaceId),
        queryFn: () => lucidSdk
            .workspaceClient(workspaceId)
            .groupManagement()
            .listGroups(),
        enabled: isQueryEnabled,
        networkMode: 'always',
    });
    return { query };
};
_react_refresh_temp_1(useGroupsByWorkspaceId, "tSAErbeuob4/XfdcEqZwDWAyuKA=", false, () => [useLucidSdk, useCurrentMemberByWorkspaceId, useGetWorkspaceLoginStatus, useQuery]);
